import React from 'react';
import { _ } from '../../../functions/translator';

class AppartmentInfo extends React.Component{

    render(){

        let appartmentId = this.props.cardsGroup.attributes.appartment_id;
        let appartmentValue = appartmentId ? this.props.appartments[appartmentId].attributes.name : _('Ninguno');

        let apparmentDefinition = _("Departamento");

        if (this.props.customcard) {
            if (!this.props.customcard.attributes.appartment_id) return <div></div>;
            apparmentDefinition = this.props.customcard.attributes.appartment_id;
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ apparmentDefinition }</p>
                <span className='text card-description'>{ appartmentValue }</span>
            </div>
        );
    }
}

export default AppartmentInfo;